.ag{aspect-ratio:1/1;}